import React from "react";
import { FaMicrochip, FaRobot } from "react-icons/fa";
import Hero from "../../components/hero/hero.component";
import user1 from "../../assets/img/one.png";
import user2 from "../../assets/img/two.png";
import user3 from "../../assets/img/three.png";
import RoboticsImg from "../../assets/img/robotics.svg";
import StatsSection from "../../components/cyber-security/StatSection";
import CoursePathway from "../../components/coursepathway/Coursepathway";
import WhyChoose from "../../components/iot/WhyChoose";
import LearningCard from "../../components/cyber-security/Learning-card";
import OnsiteImg from "../../assets/img/Image.svg";
// import OnlineImg from "../../assets/online-learning.png";
import Footer from "../../components/footer/footer.component";

const IOTautomation = () => {
  const learningModes = [
    {
      id: 1,
      title: "Onsite Learning",
      description:
        "Join us at our state-of-the-art training center for immersive, face-to-face instruction and networking.",
      footer: "Ogbomoso & Lagos Centers",
      image: OnsiteImg,
      type: "onsite",
    },
    {
      id: 2,
      title: "Online Learning",
      description:
        "Learn from anywhere in the world with live instructor-led sessions and recorded modules accessible 24/7.",
      footer: "Worldwide Access",
      backColor: "bg-[#004AC6]",

      //   image: OnlineImg,
      type: "online",
    },
  ];

  const features = [
    {
      id: 1,
      title: "Robotics",
      description:
        "Design, build, and program intelligent robots for automation and real-world applications.",
      icon: FaRobot,
    },
    {
      id: 2,
      title: "Embedded Systems",
      description:
        "Develop smart devices using microcontrollers, sensors, and embedded programming.",
      icon: FaMicrochip,
    },
  ];
  const enrollMessage = encodeURIComponent(
    `Hello, I'm interested in your IoT /Robotics Training Program at Cephas ICT Hub. 
   
    I'd like to know more about the course, including the duration, training schedule, fees, learning format(online or onsite), and how to register.
    
    I look forward to your response. Thank you!
    `,
  );

  const contactMessage = encodeURIComponent(
    "Hello, I'm interested in your  IoT /Robotics  Training Program at Cephas ICT Hub. I'd like to know more about the course.",
  );
  return (
    <div>
      <Hero
        pretitle="IOT|Robotics Training Program"
        title={
          <>
            Become a Certified
            <br />
            <span className="text-[#030A49]"> IoT & Robotics</span>
            <br />
            Automation Engineer
          </>
        }
        description={
          "Master the intersection of embedded systems, industrial robotics, and AI. Gain hands-on experience with industry-standard hardware and build the future of smart manufacturing."
        }
        price="₦600,000"
        duration="6 Months"
        primaryLink={{
          href: `https://wa.me/2348141335945?text=${enrollMessage}`,
          text: "Enroll Now",
        }}
        secondaryLink={{
          href: `https://wa.me/2348141335945?text=${contactMessage}`,
          text: "Contact Us",
        }}
        users={[user1, user2, user3]}
        imageSrc={RoboticsImg}
        features={features}
      />

      <div>
        <StatsSection />
      </div>

      <CoursePathway />

      <WhyChoose />

      <section className="bg-[#F5F6F8] md:py-20 py-6 px-4 sm:px-6 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14 px-2 sm:px-0">
            <h2 className="text-3xl  text-[#081B33] mb-3 sm:text-4xl md:text-5xl">
              Flexible <span className="text-[#EFA632]">Learning</span> Modes
            </h2>

            <p className="text-gray-500 text-base sm:text-lg">
              Choose the path that fits your schedule.
            </p>
          </div>

          <div className="grid gap-8 md:grid-cols-2">
            {learningModes.map((mode) => (
              <LearningCard
                key={mode.id}
                {...mode}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#0F172A] max-w-7xl mx-auto rounded-xl md:px-0 px-4 p-4 my-10 sm:py-20">
        <div className="mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6">
          <h2 className="md:text-4xl text-2xl leading-tight text-white">
            Ready to Build the Robots of Tomorrow?
          </h2>

          <p className="mt-6 md:text-base text-sm max-w-2xl leading-7 text-blue-100">
            Batch 14 starts next month. Secure your spot in the most
            comprehensive robotics program in the region.
          </p>

          <div className="mt-10  w-full flex items-center justify-center gap-4 sm:w-auto sm:flex-row">
            <a
              href={`https://wa.me/2348141335945?text=${contactMessage}`}
              // download="IoT Career Guide.pdf"
            >
              <button
                type="button"
                className="rounded-xl bg-[#E17A01] px-8 py-3 font-semibold text-white transition hover:bg-[#9c580c]"
              >
                Start Your Journey Today
              </button>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IOTautomation;
